module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "data-form"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "disabled": _vm.disabled,
      "model": _vm.formModel,
      "rules": _vm.cachedRules,
      "label-position": _vm.labelPosition,
      "label-width": _vm.labelWidth,
      "size": _vm.size
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.validate($event)
      }
    }
  }, [_vm._l((_vm.visibleFormFields), function(props) {
    return _c('el-form-item', {
      key: props.key,
      attrs: {
        "label": props.type !== 'hidden' ? _vm.$t('label.' + (props.label || props.key)) : '',
        "prop": props.key
      }
    }, [(props.type === 'radio') ? _c('el-radio-group', {
      attrs: {
        "disabled": props.disabled
      },
      on: {
        "change": _vm.change
      },
      model: {
        value: (_vm.formModel[props.key]),
        callback: function($$v) {
          _vm.$set(_vm.formModel, props.key, $$v)
        },
        expression: "formModel[props.key]"
      }
    }, _vm._l((props.options), function(item) {
      return _c('el-radio', {
        key: item.value,
        attrs: {
          "border": "",
          "label": item.value
        }
      }, [_vm._v(_vm._s(_vm.$t(item.label)))])
    })) : (props.type === 'select') ? _c('el-select', {
      attrs: {
        "filterable": "",
        "remote": !(!_vm.remoteMethod(props.key)),
        "multiple": props.multiple,
        "remote-method": _vm.remoteMethod(props.key),
        "placeholder": props.placeholder && _vm.$t('placeholder.' + props.key),
        "disabled": props.disabled,
        "clearable": true
      },
      on: {
        "change": function () {
          var args = [], len = arguments.length;
          while ( len-- ) args[ len ] = arguments[ len ];

          _vm.change.apply(void 0, args);
          props.change && props.change.apply(props, args);
        }
      },
      model: {
        value: (_vm.formModel[props.key]),
        callback: function($$v) {
          _vm.$set(_vm.formModel, props.key, $$v)
        },
        expression: "formModel[props.key]"
      }
    }, _vm._l((props.options), function(item) {
      return _c('el-option', {
        key: item.value,
        attrs: {
          "label": _vm.$t(item.label),
          "value": item.value
        }
      })
    })) : (props.type === 'checkbox') ? _c('el-checkbox', {
      attrs: {
        "disabled": props.disabled
      },
      on: {
        "change": _vm.change
      },
      model: {
        value: (_vm.formModel[props.key]),
        callback: function($$v) {
          _vm.$set(_vm.formModel, props.key, $$v)
        },
        expression: "formModel[props.key]"
      }
    }) : (props.type === 'switch') ? _c('el-switch', {
      attrs: {
        "disabled": props.disabled
      },
      on: {
        "change": _vm.change
      },
      model: {
        value: (_vm.formModel[props.key]),
        callback: function($$v) {
          _vm.$set(_vm.formModel, props.key, $$v)
        },
        expression: "formModel[props.key]"
      }
    }) : (props.type === 'datetime' ||  props.type === 'date') ? _c('el-date-picker', {
      attrs: {
        "disabled": props.disabled,
        "format": props.format,
        "type": props.type,
        "placeholder": props.placeholder && _vm.$t('placeholder.' + props.key),
        "time-arrow-control": ""
      },
      on: {
        "change": _vm.change
      },
      model: {
        value: (_vm.formModel[props.key]),
        callback: function($$v) {
          _vm.$set(_vm.formModel, props.key, $$v)
        },
        expression: "formModel[props.key]"
      }
    }) : (props.type === 'time') ? _c('el-time-picker', {
      attrs: {
        "disabled": props.disabled,
        "is-range": "",
        "format": props.format,
        "picker-options": props.options,
        "placeholder": props.placeholder && _vm.$t('placeholder.' + props.key)
      },
      on: {
        "change": _vm.change
      },
      model: {
        value: (_vm.formModel[props.key]),
        callback: function($$v) {
          _vm.$set(_vm.formModel, props.key, $$v)
        },
        expression: "formModel[props.key]"
      }
    }) : (props.type === 'number') ? _c('el-input-number', {
      attrs: {
        "max": props.max,
        "min": props.min,
        "step": props.step,
        "disabled": props.disabled
      },
      on: {
        "change": function($event) {
          _vm.changeNum(props.key)
        }
      },
      model: {
        value: (_vm.formModel[props.key]),
        callback: function($$v) {
          _vm.$set(_vm.formModel, props.key, $$v)
        },
        expression: "formModel[props.key]"
      }
    }) : _c('el-input', {
      attrs: {
        "type": props.type,
        "disabled": props.disabled,
        "placeholder": props.placeholder && _vm.$t('placeholder.' + props.key)
      },
      on: {
        "change": function($event) {
          props.type === 'number' ? _vm.changeNum(props.key) : _vm.change()
        }
      },
      model: {
        value: (_vm.formModel[props.key]),
        callback: function($$v) {
          _vm.$set(_vm.formModel, props.key, $$v)
        },
        expression: "formModel[props.key]"
      }
    })], 1)
  }), _vm._v(" "), _c('div', {
    style: ({
      marginLeft: _vm.hideButtons ? _vm.labelWidth : 0
    })
  }, [_vm._t("default")], 2), _vm._v(" "), (!_vm.hideButtons) ? _c('el-form-item', [(!_vm.buttons) ? [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.validate()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.' + _vm.submitLabel)))])] : _vm._l((_vm.buttons), function(b) {
    return _c('el-button', {
      attrs: {
        "type": b.type || 'primary',
        "size": b.size || 'large',
        "icon": b.icon &&  'el-icon-' + b.icon,
        "loading": _vm.isLoading
      },
      on: {
        "click": function($event) {
          _vm.validate(b)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('button.' + b.label)))])
  }), _vm._v(" "), (_vm.cancel) ? _c('el-button', {
    attrs: {
      "type": "default",
      "size": "large",
      "plain": true
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v(_vm._s(_vm.$t('button.cancel')))]) : _vm._e()], 2) : _vm._e()], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0e2601bb!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DataForm.vue
// module id = 1120
// module chunks = 2